import { User } from "@/types/types";
import { getSubscriptionPlan } from "@/utils/subscriptionLevels/getSubscriptionPlan";

export const allowWavConversions = (
  stripeSubscriptionId: User["stripeSubscriptionId"]
) => {
  const subscriptionPlan = getSubscriptionPlan(stripeSubscriptionId);

  if (subscriptionPlan === "first") {
    return true;
  } else if (subscriptionPlan === "second") {
    return true;
  } else if (subscriptionPlan === "third") {
    return true;
  }

  // Free plan
  return false;
};
